import { toast } from "react-toastify";
import { postLoginInstance } from "../../utils";
import { API_LIMIT, durationObj, MAX_LIMIT, START_PAGE } from "../../utils/Constant";
import { getAllCalenderData, getAllCalenderFilterData, getAllSubdomainData, getAllTypesData, getSubdomainTypesData, getTargetedListData } from "./SubDomainAction";
import { getLabelByValue, filterVerifiedItems } from "../../utils/ReusableFunctions";

export const getAllTypeApi = (ctx = null) => {
  const { verifyUrl = false } = ctx?.state ?? {};
  return function (dispatch, getState) {

    return postLoginInstance.get(`sso/types?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${ctx?.state.pageSize || API_LIMIT}&pageNumber=${ctx?.state.currentPage || START_PAGE}`)
      .then((res) => {

        // return ctx.setState({ dummyData: res.data.data ,});

        dispatch(getAllTypesData(res.data.data, ctx?.state.currentPage || START_PAGE));
        let options = filterVerifiedItems(res.data.data.list).map((item) => ({
          value: item.uuid,
          label: item.type
        }));

        ctx.setState({ typesOptions: options })
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      })
  }

};
export const getAllSubdomainTypeApi = (ctx = null) => {
  const { verifyUrl = false } = ctx?.state ?? {};
  return function (dispatch, getState) {

    return postLoginInstance.get(`sub-domain/types?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${ctx?.state.pageSize || API_LIMIT}&pageNumber=${ctx?.state.currentPage || START_PAGE}`)
      .then((res) => {

        // return ctx.setState({ dummyData: res.data.data ,});

        dispatch(getSubdomainTypesData(res.data.data, ctx?.state.currentPage || START_PAGE));
        let options = filterVerifiedItems(res.data.data.list).map((item) => ({
          value: item.uuid,
          label: item.type
        }));

        ctx.setState({ subdomainTypesOptions: options })
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      })
  }

};
export const getAllSubdomainApi = (ctx = null) => {
  const { verifyUrl = false } = ctx?.state ?? {};
  return function (dispatch, getState) {

    return postLoginInstance.get(`sub-domain?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${ctx?.state.pageSize || API_LIMIT}&pageNumber=${ctx?.state.currentPage || START_PAGE}`)
      .then((res) => {

        // return ctx.setState({ dummyData: res.data.data ,});
        dispatch(getAllSubdomainData(res.data.data, ctx?.state.currentPage || START_PAGE));

      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      })
  }

};
export const getSubdomainDetailsApi = (path, ctx) => {
  console.log(ctx, "subdomain")
  return postLoginInstance.get(`${path}/${ctx.props?.location?.state?.id || ctx.props.match?.params.id}`)
    .then((res) => {
      return ctx.setState({ data: res.data.data });

    })
    .catch((err) => {
      console.log('Eroorr', err)
      toast.error(err?.response?.data?.message || 'Something went wrong.');
    })
};
export const getDetailsSubdomainApi = (path, ctx, plansOptions) => {
  console.log(ctx, "subdomain")
  return postLoginInstance.get(`${path}/${ctx.props?.location?.state?.id || ctx.props.match?.params.id}`)
    .then((res) => {


      const d = res.data.data
      const variationData = plansOptions?.find(ele => ele?.uuid == d?.premiumPlan?.uuid)

      const processedModules = d.modules?.map(module => {
        const processedModule = {
          uuid: module.uuid,
          moduleName: module.moduleName,
          amc: module.amcs.map(amc => amc.uuid), // Join amcUuids with comma
          creator: module.contentCreators?.map(creator => creator.uuid), // Join contentCreatorUuids with comma
          uuids: '', // Initialize uuids as an empty string,
          isAmcShowContent: module?.amcs?.length > 0 ? true : false,
          selectionType: module?.uuids?.length === 1 && module?.contentCreators?.length === 0 ? "single" : "multiple"
        };
        if(module?.isOnlySsoSpecificContentAllowed) {
          processedModule.isOnlySsoSpecificContentAllowed = module.isOnlySsoSpecificContentAllowed;
          processedModule.selectionType = ""
        }

        if (module?.uuids?.length > 0 && module?.contentCreators?.length === 0) {
          // Case 1: Set states based on `moduleName`
          switch (module.moduleName) {
            case "CONTENT":
              processedModule.selectedContent = module?.uuids;
              break;
            case "CAMPAIGN":
              processedModule.campaign = module?.uuids?.map((item) => item.uuid);
              break;
            case "EVENT":
              processedModule.event = module?.uuids?.map((item) => item.uuid);
              break;
            case "LANGUAGE":
              processedModule.language = module?.uuids?.map((item) => item.uuid);
              break;
            case "TOOLS":
              processedModule.tools = module?.uuids?.map((item) => item.uuid);
              break;
            case "PERSONALIZE":
              processedModule.personalize = module?.uuids?.map((item) => item.uuid);
              break;
            case "CATEGORY":
              processedModule.category = module?.uuids?.map((item) => item.uuid);
              break;
            default:
              break;
          }
        } else if (module?.contentCreators?.length > 0) {
          // Case 2: Clear all states
          processedModule.selectedContent = [];
          processedModule.campaign = [];
          processedModule.event = [];
          processedModule.language = [];
          processedModule.tools = [];
          processedModule.personalize = [];
          processedModule.category = [];
        }


        return processedModule;
      });
      return ctx.setState({
        editData: d, subdomainUuid: d?.uuid || "", companyName: d?.companyName || "", uploadImage: d?.companyLogo || null, amcContent: d?.amc?.map(item => item?.uuid) || "", creatorContent: d?.contentCreator?.map(item => item.uuid) || "", amcEvent: d?.amc?.map(item => item?.uuid) || "", creatorEvent: d?.contentCreator?.map(item => item.uuid) || "", link: d?.websiteLink || "",
        contact: d?.mobileNumber || "",
        email: d?.emailAddress || "",
        logoPosition: d?.logoPosition || "",
        subdomainType: d?.ssoPartnerType?.uuid || "", modules: processedModules,
        premium: d?.premiumPlan?.uuid,
        subPremiumPlan: variationData, subPremium: d?.subPremiumPlan?.uuid,
        subPremiumPlanVariation: variationData?.subPremiumPlan?.find(ele => ele?.uuid == d?.subPremiumPlan?.uuid), variation: d?.subPremiumPlanVariation?.uuid, creatorContent: d?.contentsAllowedOf
          ?.filter(item => item?.contentCreatorName)
          .map(item => item?.uuid || ""),
        isAdminAllowed: d?.allowPartnerAdminPanel,
        isUserViewAllowed: d?.allowPartnerAdminUserDetails,
        isShowLogo: d?.companyLogoVisibility,
        isCompanyLogo: d?.companyLogoVisibility && d?.companyLogoText === "",
        isBoth: d?.companyLogoVisibility && d?.companyLogoText !== "",
        isPowered: d?.companyLogoText === "Powered By" ? true : false,
        isBrought: d?.companyLogoText === "Brought to you by" ? true : false,
        isSubscriptionAllowed: d?.allowSubscriptionPlanPage,
        isTFPAllowed: d?.allowSubscriptionPlanPage && d?.subscriptionPlanPageLink
          === "",
        isOtherLinkAllowed: d?.subscriptionPlanPageLink !== "",

        otherLink: d?.subscriptionPlanPageLink,

        allowedSubPremiumPlans: d?.allowedSubPremiumPlans?.split(",") || [],
        primaryColor: d?.primaryColor || "",

      });
    })
    .catch((err) => {
      console.log('Eroorr', err)
      toast.error(err?.response?.data?.message || 'Something went wrong.');
    })
};

export const getAllCalenderApi = (ctx = null) => {
  ctx?.setState?.({ isLoading: true })
  const { verifyUrl = false } = ctx?.state ?? {};
  return function (dispatch, getState) {

    return postLoginInstance.get(`calender?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${ctx?.state.pageSize || API_LIMIT}&pageNumber=${ctx?.state.currentPage || START_PAGE}`)
      .then((res) => {

        // return ctx.setState({ dummyData: res.data.data ,});
        dispatch(getAllCalenderData(res.data.data, ctx?.state.currentPage || START_PAGE));

      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      }).finally(() => {
        ctx?.setState?.({ isLoading: false})
      })
  }

};
export const getAllCalenderFilterApi = (ctx = null) => {
  ctx?.setState?.({ isLoading: true })
  const { verifyUrl = false } = ctx?.state ?? {};
  return function (dispatch, getState) {

    return postLoginInstance.get(`calender-filter?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${ctx?.state.pageSize || API_LIMIT}&pageNumber=${ctx?.state.currentPage || START_PAGE}`)
      .then((res) => {

        // return ctx.setState({ dummyData: res.data.data ,});
        dispatch(getAllCalenderFilterData(res.data.data, ctx?.state.currentPage || START_PAGE));
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      }).finally(() => {
        ctx?.setState?.({ isLoading: false})
      })
  }

};
export const getCalenderDetailsApi = (path, ctx) => {
  console.log(ctx, "subdomain")
  return postLoginInstance.get(`${path}/${ctx.props?.location?.state?.id || ctx.props.match?.params.id}`)
    .then((res) => {
      return ctx.setState({ data: res.data.data });

    })
    .catch((err) => {
      console.log('Eroorr', err)
      toast.error(err?.response?.data?.message || 'Something went wrong.');
    })
};

export const getAllCalendersDataApi = (ctx = null) => {
  const { verifyUrl = false } = ctx?.state ?? {};
  return function (dispatch, getState) {

    return postLoginInstance.get(`calender?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${ctx?.state.pageSize || API_LIMIT}&pageNumber=${ctx?.state.currentPage || START_PAGE}`)
      .then((res) => {
        const option = filterVerifiedItems(res.data.data.list).map((item) => ({
            label: item.templateName,
            value: item.uuid
          }));
        ctx.setState({
          personalizationOptions: option
        })

      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      })
  }

};
export const getAllToolsDataApi = (ctx = null) => {
  const { verifyUrl = false } = ctx?.state ?? {};
  return function (dispatch, getState) {

    return postLoginInstance.get(`tool?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${ctx?.state.pageSize || API_LIMIT}&pageNumber=${ctx?.state.currentPage || START_PAGE}`)
      .then((res) => {
        const option = filterVerifiedItems(res.data.data.list).map((item) => ({
            label: item.toolName,
            value: item.uuid
          }));
        ctx.setState({
          toolOptions: option
        })

      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      })
  }

};
export const getAllModulesDataApi = (ctx = null) => {
  const { verifyUrl = false } = ctx?.state ?? {};
  return function (dispatch, getState) {

    return postLoginInstance.get(`sso/master-modules?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${ctx?.state.pageSize || API_LIMIT}&pageNumber=${ctx?.state.currentPage || START_PAGE}`)
      .then((res) => {
        const option = filterVerifiedItems(res.data.data.list).map((item) => ({
            label: item.moduleName,
            value: item.moduleName,
            uuid: item.uuid
          }));
        ctx.setState({
          moduleNameOptions: option
        })


      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      })
  }

};
export const getTargetedContentSubdomainApi = (ctx = {}, filter) => {
  const { verifyUrl = false } = ctx?.state ?? {};
  return function (dispatch, getState) {
    const params={
      pageSize: MAX_LIMIT,
      pageNumber: START_PAGE
    }
    if(filter?.creator && filter?.creator.length>0){
      const labels = filter.creator.map(val=> getLabelByValue(val,ctx.state?.creatorList)).filter(Boolean);

      params['creator']=labels.join(',')
    }
    if(filter?.amc && filter?.amc.length>0){
      const labels = filter.amc.map(val=> getLabelByValue(val,ctx.state?.amcOption)).filter(Boolean);
      params['amc']=labels.join(',')
    }
  

    return postLoginInstance
      .get(
        `targetedContent`,{params}
      )
      .then((res) => {
        const option = filterVerifiedItems(res?.data?.data?.list).map((item) => ({
            label: item?.targetedContentName,
            value: item.uuid
          }));
        ctx.setState({
          targetedContentOptions: option

        })
      }).catch((error) => {
        toast.error(error?.response?.data?.message || 'Something went wrong.');
      })
  };
};
